import React from "react";

const APP_DOMAIN = "soyapostol.org";

// Domains rendered as clickable external links inside the Settings
// "Credits" + "Fair Use" blocks. Every match (case-insensitive) is wrapped
// in an <a target="_blank"> with a favicon decorator.
export const SOURCE_LINKS = [
    { domain: "evangelizo.org",   url: "https://evangelizo.org" },
    { domain: "evangeli.net",     url: "https://evangeli.net" },
    { domain: "divineoffice.org", url: "https://divineoffice.org" },
    { domain: "ibreviary.com",    url: "https://www.ibreviary.com" },
    { domain: "vaticannews.va",   url: "https://www.vaticannews.va" },
    { domain: "aciprensa.com",    url: "https://www.aciprensa.com" },
    { domain: "ewtnnews.com",     url: "https://www.ewtnnews.com" },
];

// Words that must render in bold liturgical purple inside the "Quiénes
// Somos" body. Order matters only in that longer matches should be tried
// first so a substring doesn't steal a larger token.
export const ES_EMPHASIS = [
    "Corazones A La Obra",
    "Señor Jesucristo",
    "Virgen María",
    "¡Soy Apóstol!",
    "tiempo",
    "talento",
    "tesoro",
];
export const EN_EMPHASIS = [
    "Corazones A La Obra",
    "Lord Jesus Christ",
    "Virgin Mary",
    "I Am an Apostle!",
    "time",
    "talent",
    "treasure",
];

const escape = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

// Emphasise whole-word matches + embed the soyapostol.org link. Returns
// an array of React nodes preserving the original textual order.
export function decorateParagraph(text, emphasisWords) {
    // Escape + longest-first so "Corazones A La Obra" wins over sub-tokens.
    const sorted = [...emphasisWords].sort((a, b) => b.length - a.length);
    const emphRe = new RegExp(`(${sorted.map(escape).join("|")})`, "g");
    const linkRe = /(soyapostol\.org)/g;

    // First split by soyapostol.org so the link is independent of emphasis.
    const linkParts = text.split(linkRe);
    const nodes = [];
    linkParts.forEach((chunk, li) => {
        if (chunk === APP_DOMAIN) {
            nodes.push(
                <a
                    key={`link-${li}`}
                    href={`https://${APP_DOMAIN}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="settings-soyapostol-link"
                    className="text-purple-700 font-semibold hover:text-purple-900 underline decoration-purple-300 underline-offset-4 transition-colors"
                >
                    {APP_DOMAIN}
                </a>,
            );
            return;
        }
        // For the non-link chunk, split by emphasis words.
        const parts = chunk.split(emphRe);
        parts.forEach((p, pi) => {
            if (!p) return;
            if (sorted.includes(p)) {
                nodes.push(
                    <strong
                        key={`em-${li}-${pi}`}
                        className="font-semibold text-purple-700"
                    >
                        {p}
                    </strong>,
                );
            } else {
                nodes.push(<React.Fragment key={`t-${li}-${pi}`}>{p}</React.Fragment>);
            }
        });
    });
    return nodes;
}

// Render a paragraph turning every known source-domain occurrence into a
// clickable external link with a favicon. Used for Credits + Fair-Use.
export function linkifySources(text) {
    if (!text) return null;
    const pattern = SOURCE_LINKS.map((s) => escape(s.domain)).join("|");
    if (!pattern) return text;
    const re = new RegExp(`(${pattern})`, "gi");
    const parts = text.split(re);
    return parts.map((p, i) => {
        const match = SOURCE_LINKS.find(
            (s) => s.domain.toLowerCase() === p.toLowerCase(),
        );
        if (!match) return <React.Fragment key={i}>{p}</React.Fragment>;
        return (
            <a
                key={i}
                href={match.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`settings-source-link-${match.domain}`}
                className="inline-flex items-baseline gap-1.5 text-purple-700 hover:text-purple-900 underline decoration-purple-300 underline-offset-4 transition-colors"
            >
                <img
                    src={`https://www.google.com/s2/favicons?domain=${match.domain}&sz=32`}
                    alt=""
                    width="16"
                    height="16"
                    loading="lazy"
                    decoding="async"
                    referrerPolicy="no-referrer"
                    aria-hidden="true"
                    className="self-center w-4 h-4 rounded-sm shrink-0"
                    onError={(e) => { e.currentTarget.style.display = "none"; }}
                />
                <span>{p}</span>
            </a>
        );
    });
}
